export function getProgressInPercent(currentTime: number, duration: number) {
    if (currentTime <= 0) return 0
    if (duration <= 0) return 0

    return (currentTime * 100) / duration
}
